import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Header } from './Header'
import { Footer } from './Footer'

type Props = {
  orderStepIds: string[]
}

export function Content(props: Props) {
  const { ready } = useConfigureController(props.orderStepIds)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />} maxWidth={644}>
      <Body />
    </ModalContent>
  )
}
